(() => {
  if (!document.querySelector(".shopify-section--internal-navigation")) {
    return;
  }

  const internalNavigationItems = document.querySelectorAll(
    ".internal-navigation__item"
  );

  function scrollToElementWithHeader(evt) {
    internalNavigationItems.forEach((element) => {
      element.classList.remove("active");
    });

    evt.target.closest(".internal-navigation__item").classList.add("active");

    const elementId = (evt.target.href || "").split("#")[1] || null;

    if (!elementId) {
      return;
    }

    const element = document.getElementById(elementId);

    if (!element) {
      return;
    }

    evt.preventDefault();

    const header = document.getElementById("shopify-section-header");
    const internalNav = document.querySelector(
      ".shopify-section--internal-navigation"
    );
    const elementPosition = element.getBoundingClientRect().top;
    let headerHeight = header.clientHeight + internalNav.clientHeight;

    /* Edited by Fabiana for the gift guide 2024 page */
    if(document.body.classList.contains('template-page-gift-guide-2024') && window.innerWidth < 760) {
      headerHeight = header.clientHeight;
    }

    window.scrollTo({
      top: elementPosition + window.scrollY - headerHeight,
      behavior: "smooth",
    });

    const newUrl = window.location.href.split("#")[0] + `#${elementId}`;
    history.replaceState(null, null, newUrl);
  }

  document
    .querySelectorAll(
      '.internal-navigation__item:not(.internal-navigation__item--initialized) a[href^="#"]'
    )
    .forEach((element) => {
      element
        .closest(".internal-navigation__item")
        .classList.add("internal-navigation__item--initialized");

      element.addEventListener("click", scrollToElementWithHeader);
    });
})();
